import axios from "axios";
import { baseURL } from "./apiUrl";

const axiosInstance = axios.create({ baseURL });

//success response
const success = (response) => response;

//error response
const error = (error) => {
  return Promise.reject((error?.response && error.response.data) || error);
};

axiosInstance.interceptors.response.use(success, error);

export default axiosInstance;
